import React, { createContext, useReducer } from 'react';

export const VideoRecordingContext = createContext();

// This is the initial state for the video recording context
// It includes properties to track if recording is active,
// the function to stop recording, and the current slot ID.

const initialVideoRecordingState = {
  isRecording: false,
  stopRecording: null,
  currentSlotId: null,
  inMemoryVideoRecord: null
};

// Video recording context is used to manage recording state across the application
// this is useful for stopping the recording when the section or slot times out

const videoRecordingReducer = (state, action) => {
  switch (action.type) {
    case 'SET_RECORDING_STATE':
      return {
        ...state,
        isRecording: action.payload.isRecording,
        stopRecording: action.payload.stopRecording,
        currentSlotId: action.payload.currentSlotId
      };
    case 'CLEAR_RECORDING_STATE':
      return {
        ...state,
        isRecording: false,
        stopRecording: null,
        currentSlotId: null
      };
    case 'SET_IN_MEMORY_VIDEO_RECORD':
      return {
        ...state,
        inMemoryVideoRecord: action.payload.inMemoryVideoRecord
      };
    default:
      return state;
  }
};

export const VideoRecordingProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    videoRecordingReducer,
    initialVideoRecordingState
  );

  return (
    <VideoRecordingContext.Provider value={{ state, dispatch }}>
      {children}
    </VideoRecordingContext.Provider>
  );
};
